/**
 * @fileoverview PATCH handler for the "/app_groups/:app_group_id/placements/:id" endpoint
 */
import fetch from "@lib/fetch";

import { buildPlacementTargetingBody } from "@dashboardApi/apis/placementsShared";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacementsIdCacheKeys } from "./constants";
import type {
  PatchAppGroupsAppGroupIdPlacementsIdProps,
  PatchAppGroupsAppGroupIdPlacementsIdResult,
} from "./types";

export const patchAppGroupsAppGroupIdPlacementsId = reactQueryMutationAdapter(
  appGroupsAppGroupIdPlacementsIdCacheKeys,
  ({
    id,
    placementId,
    name,
    description,
    appGroupId,
    targeting,
  }: PatchAppGroupsAppGroupIdPlacementsIdProps): Promise<PatchAppGroupsAppGroupIdPlacementsIdResult> => {
    return fetch(
      `/app_groups/${appGroupId}/placements/${id}`,
      "PATCH",
      {
        placement_id: placementId,
        name,
        description,
        // `targeting` is only included in the request body when the caller explicitly passed a
        // value -- including `null`. Omitting the key when `targeting` is `undefined` tells the
        // backend "no change requested"; sending an explicit `targeting: null` in that case would
        // incorrectly clear any previously saved targeting.
        ...(targeting !== undefined && { targeting: buildPlacementTargetingBody(targeting) }),
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
